<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- SHO layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'sho') {
    <sho-layout></sho-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'empty') {
    <empty-layout></empty-layout>
}
